export type LoginPortal = 'student' | 'tutor' | 'admin' | 'school' | 'affiliate'

export interface LoginPreferences {
  email: string
  rememberMe: boolean
}

function storageKey(portal: LoginPortal): string {
  return `zimark_login_prefs_${portal}`
}

export function loadLoginPreferences(portal: LoginPortal): LoginPreferences | null {
  if (typeof window === 'undefined') return null
  try {
    const raw = localStorage.getItem(storageKey(portal))
    if (!raw) return null
    const parsed = JSON.parse(raw) as LoginPreferences
    if (!parsed || typeof parsed.email !== 'string') return null
    return {
      email: parsed.email,
      rememberMe: parsed.rememberMe !== false,
    }
  } catch {
    return null
  }
}

export function saveLoginPreferences(portal: LoginPortal, prefs: LoginPreferences): void {
  if (typeof window === 'undefined') return
  if (prefs.rememberMe && prefs.email) {
    localStorage.setItem(storageKey(portal), JSON.stringify(prefs))
    return
  }
  localStorage.removeItem(storageKey(portal))
}
